import { api } from './client';
import type { FormDTO } from './types';

export const formsApi = {
  list: () => api.get<{ forms: FormDTO[] }>('/forms'),
  get: (id: string) => api.get<{ form: FormDTO }>(`/forms/${id}`),
  create: (input: Record<string, unknown>) => api.post<{ form: FormDTO }>('/forms', input),
  update: (id: string, input: Record<string, unknown>) => api.patch<{ form: FormDTO }>(`/forms/${id}`, input),
  delete: (id: string) => api.delete<{ message: string }>(`/forms/${id}`),
};
